export enum ForumRoutes {
  BACKGAMMON = 'backgammon',
  СRIBBAGE = 'сribbage',
  GIN_RUMMY = 'gin_rummy',
  RED_MAHJONG = 'red_mahjong',
  DOMINOS = 'dominos',
  TEST = 'test',
}
